import { Navigate, Outlet, useLocation } from 'react-router';
import { Loading } from '../../components/States';
import { AccountBanned } from '../../routes/AccountBanned';
import { useMe, useSession } from './session';

/** Requires a signed-in session. */
export function RequireSession() {
  const { session, loading } = useSession();
  const location = useLocation();
  if (loading) return <Loading label="Opening Roadrunner" />;
  if (!session) return <Navigate to="/welcome" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}

/** Requires a finished profile and a verified home area (moderators may skip verification). */
export function RequireReady() {
  const { data: me, isPending, error } = useMe();
  if (isPending) return <Loading label="Opening Roadrunner" />;
  if (error || !me) return <Navigate to="/welcome" replace />;
  if (me.status === 'banned') return <AccountBanned reason={me.statusReason} />;
  if (!me.displayName) return <Navigate to="/onboarding/name" replace />;
  if (!me.location && me.role === 'member') return <Navigate to="/onboarding/location" replace />;
  return <Outlet />;
}

export function RequireRole({ role }: { role: 'moderator' | 'admin' }) {
  const { data: me } = useMe();
  const allowed = role === 'admin' ? me?.role === 'admin' : me?.role === 'admin' || me?.role === 'moderator';
  if (!allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
